import React, { useEffect, useState } from 'react';
import AppBreadcrumb from '../../Shared/AppBreadcrumb';
import FecthingSpinner from '../../Shared/FecthingSpinner';
import httpService from "../../../services/http.service";
import * as logger from "../../../services/logger.service";
import moment from 'moment';
import { getUserFullName } from '../../../utils';
import MyOpinionLogo from "../../../assets/images/MyOpinion_Logo_Head.png";

const PaymentDetails = ({ match }) => {
    const { id } = match.params;

    const [payment, setPayment] = useState(null);
    const [fetching, setFetching] = useState(true);
    const [updating, setUpdating] = useState(false);
    const [status, setStatus] = useState('');

    const fetchData = async () => {
        try {
            const response = await httpService.get(`/payments/${id}`);
            const paymentData = response.data?.data;
            logger.debug('Détails du paiement chargés', { paymentId: id });
            setPayment(paymentData);
            setStatus(paymentData?.payment_status || '');
        } catch (error) {
            logger.error('Erreur chargement paiement', error);
        } finally {
            setFetching(false);
        }
    };

    const updateStatus = async () => {
        const confirm = window.confirm("Es-tu sûr de vouloir mettre à jour le statut de cette transaction ?");
        if (!confirm) return;

        try {
            setUpdating(true);
            await httpService.patch(`/payments/${payment.payment_id}`, {
                payment_status: status
            });
            alert('Statut mis à jour avec succès');
            fetchData();
        } catch (error) {
            alert('Erreur lors de la mise à jour du statut');
            logger.error('Erreur mise à jour statut paiement', error);
        } finally {
            setUpdating(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [id]);

    if (fetching) return <FecthingSpinner />;

    if (!payment) return (
        <div className="container-fluid">
            <AppBreadcrumb title="Détail du paiement" />
            <div className="alert alert-danger mt-2">Transaction introuvable.</div>
        </div>
    );

    return (
        <div className="container-fluid">
            <AppBreadcrumb title="Détail du paiement" />
            <div className="card p-4 bg-white text-dark">
                <h5 className="mb-4 text-secondary">Détails du paiement</h5>
                <div className="row">
                    {/* User Info */}
                    <div className="col-md-4 text-center mb-3">
                        <img
                            src={payment?.user?.profile?.prof_picture || MyOpinionLogo}
                            className="rounded-circle mb-3"
                            width="100"
                            height="100"
                            alt="User"
                            style={{ objectFit: 'cover' }}
                        />
                        <h6 className="mb-1">{getUserFullName(payment?.user, true)}</h6>
                        <p className="text-muted mb-4">@{payment?.user?.user_username}</p>
                        {/* <div className="col-md-6">
                            <p className="mb-1 text-muted">Balance</p>
                            <p className="font-weight-bold">{payment.user.user_wallet_balance}</p>
                        </div>
                        <div className="col-md-6">
                            <p className="mb-1 text-muted">Balance</p>
                            <p className="font-weight-bold">{payment.user.user_soutiens_count}</p>
                        </div> */}
                        <hr></hr>
                        <label className="form-label d-block mb-3">Statut: <span className={`badge ${payment.payment_status === 'success'
                            ? 'badge-success'
                            : payment.payment_status === 'pending'
                                ? 'badge-outline-secondary'
                                : 'badge-danger'
                            }`}>
                            {payment.payment_status}
                        </span></label>
                        <select
                            className="form-control mb-2"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                            disabled={updating}
                        >
                            <option value="pending">En attente</option>
                            <option value="success">Succès</option>
                            <option value="failed">Échoué</option>
                        </select>
                        <button
                            className="btn btn-primary btn-block"
                            onClick={updateStatus}
                            disabled={updating}
                        >
                            {updating ? 'Mise à jour...' : 'Mettre à jour'}
                        </button>
                    </div>

                    {/* Payment Info */}
                    <div className="col-md-8">
                        <div className="row mb-2">
                            <div className="col-md-6">
                                <p className="mb-1 text-muted">Référence</p>
                                <p className="font-weight-bold">{payment.payment_transfer_reference_no}</p>
                            </div>
                            <div className="col-md-6">
                                <p className="mb-1 text-muted">Montant</p>
                                <p className="font-weight-bold">{payment.payment_amount} {payment.payment_currency}</p>
                            </div>
                            <div className="col-md-6">
                                <p className="mb-1 text-muted">Bénéficiaire</p>
                                <p className="font-weight-bold">{payment.payment_beneficiary_name}</p>
                            </div>
                            <div className="col-md-6">
                                <p className="mb-1 text-muted">Téléphone</p>
                                <p className="font-weight-bold">{payment.payment_beneficiary_phone}</p>
                            </div>
                            <div className="col-md-6">
                                <p className="mb-1 text-muted">Type</p>
                                <p className="font-weight-bold">
                                    {payment.payment_type === 'ALL'
                                        ? 'Coins, likes et vues'
                                        : payment.payment_type === 'COIN'
                                            ? 'Coins'
                                            : payment.payment_type === 'LIKE'
                                                ? 'Likes'
                                                : 'Vues'
                                    }
                                </p>
                            </div>
                            <div className="col-md-6">
                                <p className="mb-1 text-muted">Date</p>
                                <p className="font-weight-bold">{moment(payment.payment_execution_date).format('DD/MM/YYYY HH:mm')}</p>
                            </div>
                            {payment.payment_request_type === 'DOMESTIC' ? (
                                <>
                                    <div className="col-md-6">
                                        <p className="mb-1 text-muted">Agence</p>
                                        <p className="font-weight-bold">{payment.payment_credit_account_branch}</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="mb-1 text-muted">Compte crédité</p>
                                        <p className="font-weight-bold">{payment.payment_credit_account_number}</p>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="col-md-6">
                                        <p className="mb-1 text-muted">Code banque</p>
                                        <p className="font-weight-bold">{payment.payment_destination_bank_code}</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="mb-1 text-muted">Compte bénéficiaire</p>
                                        <p className="font-weight-bold">{payment.payment_beneficiary_account_no}</p>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentDetails;
